import React from "react"

export const Timer = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipule="evenodd"
        d="M15 4.09998H12.75V5.34998C12.75 5.36158 12.7497 5.37312 12.7492 5.3846C16.8162
        5.76233 20 9.18434 20 13.35C20 17.7683 16.4183 21.35 12 21.35C7.58172 21.35 4 17.7683 4
        13.35C4 9.18434 7.18381 5.76233 11.2508 5.3846C11.2503 5.37312 11.25 5.36158 11.25
        5.34998V4.09998H9C8.58579 4.09998 8.25 3.76419 8.25 3.34998C8.25 2.93576 8.58579
        2.59998 9 2.59998H12H15C15.4142 2.59998 15.75 2.93576 15.75 3.34998C15.75 3.76419
        15.4142 4.09998 15 4.09998ZM12 19.85C15.5899 19.85 18.5 16.9398 18.5 13.35C18.5
        9.76012 15.5899 6.84998 12 6.84998C8.41015 6.84998 5.5 9.76012 5.5 13.35C5.5
        16.9398 8.41015 19.85 12 19.85ZM15.3588 9.81965C15.6517 10.1125 15.6517 10.5874
        15.3588 10.8803L13.4079 12.8312C13.4675 12.9929 13.5 13.1676 13.5 13.35C13.5
        14.1784 12.8284 14.85 12 14.85C11.1716 14.85 10.5 14.1784 10.5 13.35C10.5
        12.5215 11.1716 11.85 12 11.85C12.0843 11.85 12.167 11.8569 12.2475 11.8703L14.2981
        9.81965C14.591 9.52675 15.0659 9.52675 15.3588 9.81965Z"
        fill="#0374D6"
      />
    </svg>
  )
}
